import React, { Component } from 'react';
import { Button, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import Datetime from 'react-datetime';
export default class InvoiceSearch extends Component {
    render() {
        const { maxResults, setStateCustom, minDate, maxDate, searchInvoices, loadingInvoices } = this.props;
        const inValidMaxResults = maxResults !== "" && (maxResults > 25 || maxResults < 1);

        return <Form>
            <Col sm={12}>
                <FormGroup row>
                    <Label for="minDate" sm={4}>Min Invoice Date:</Label>
                    <Col sm={8}>
                        <Datetime id="minDate"
                            onChange={(date) => {
                                setStateCustom({ minDate: date, unpostedInvoicesQueryResult: null });
                            }}
                            defaultValue={minDate} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="maxDate" sm={4}>Max Invoice Date:</Label>
                    <Col sm={8}>
                        <Datetime id="maxDate"
                            onChange={(date) => {
                                setStateCustom({ maxDate: date, unpostedInvoicesQueryResult: null });
                            }}
                            defaultValue={maxDate} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="maxResults" sm={4}>Page Size:</Label>
                    <Col sm={8}>
                        <Input id="maxResults"
                            className={inValidMaxResults ? 'invalid-field' : ''}
                            value={maxResults}
                            onChange={(e) => { setStateCustom({ maxResults: e.target.value, unpostedInvoicesQueryResult: null }) }} />
                        <span className="maxResultsValidation invalid-field-text">
                            {inValidMaxResults && <div>*Page size must be between 1 and 25</div>}
                        </span>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="searchCompanyName" sm={4}>Company Name:</Label>
                    <Col sm={8}>
                        <Input id="searchCompanyName"
                            onChange={(e) => { setStateCustom({ searchCompanyName: e.target.value, unpostedInvoicesQueryResult: null }) }} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="searchAccountNumber" sm={4}>Account ID:</Label>
                    <Col sm={8}>
                        <Input id="searchAccountNumber"
                            onChange={(e) => { setStateCustom({ searchAccountNumber: e.target.value, unpostedInvoicesQueryResult: null }) }} />
                    </Col>
                </FormGroup>
                {
                    loadingInvoices
                        ? <div>Searching invoices...</div>
                        : <Button onClick={searchInvoices} disabled={maxResults > 25 || maxResults < 1}>Search Invoices</Button>
                }
            </Col>
        </Form>;
    }
}